import { useTranslation } from 'react-i18next'

export default function About() {
  const { t } = useTranslation('account')
  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">{t('about.title')}</h1>
      <div className="card p-6 space-y-4 text-gray-700 dark:text-gray-300">
        <p>{t('about.p1')}</p>
        <p>{t('about.p2')}</p>
        <p>{t('about.p3')}</p>
        <p>{t('about.p4')}</p>
      </div>
    </div>
  )
}
